import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        marginBottom: '20px !important',
        marginTop: '40px !important',
        fontSize: '35px',
    },
    cardContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(3),
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
           flexDirection:'column !important',
        },
    },
    cardHeader:{
        width: '100%',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        height: '150px',
        background: 'linear-gradient(to bottom right, #6A8EC9 0%, #8C74A7 30%, #D44C71 66%, #C91C6E 103%)',
        borderBottomLeftRadius: '100% 50px',
        borderBottomRightRadius: '100% 50px',
        position: 'relative',
    },
    card: {
        position:'relative',
        width: '320px',
        maxHeight: '570px',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '10px',
        textAlign: 'center',
        padding: '0px !important',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        boxShadow: theme.shadows[1],
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: theme.shadows[4],
        },
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        padding: '0px !important',
    },
    cardTitle: {
        fontWeight: "bold",
        textTransform: 'uppercase',
        marginBottom: theme.spacing(2),
        color:'#fff',
    },
    featureList: {
        flexGrow: 1,
        maxHeight: '300px',
        overflowY: 'auto',
        marginTop:'17px !important',
        padding: '0',
        textAlign:'center',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': {
            width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.grey[400],
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: theme.palette.grey[500],
        },
    },
    featureListItem:{
        padding:'0px !important',
        textAlign:'center !important',
    },
    subscribeButton: {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        alignSelf: 'center',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },
    },
}));
export default useStyles;